export default {
    adjustments: {
        title: "Justeringer",
        reset: "Nulstil",
        light: {
            title: "Lys",
            brightness: "Lysstyrke",
            contrast: "Kontrast",
            shadows: "Skygger",
        },
        color: {
            title: "Farve",
            saturation: "Mætning",
            temperature: "Temperatur",
            blacks: "Sorte",
            whites: "Hvide",
        },
        detail: {
            title: "Detalje",
            clarity: "Klarhed",
            sharpness: "Skarphed",
            blur: "Slør",
        },
    },
};
